var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHealth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 3.77778L8.42681 3.4553C9.58606 2.57942 11.1663 2.51212 12.3958 3.28627C14.261 4.46066 14.5867 7.04734 13.0708 8.64744L8.72595 13.2337C8.33152 13.6501 7.66848 13.6501 7.27405 13.2337L2.92915 8.64744C1.41327 7.04734 1.73895 4.46066 3.60417 3.28627C4.83369 2.51212 6.41394 2.57942 7.57319 3.4553L8 3.77778Z",
    fill: "#002A69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealth);
export default __webpack_public_path__ + "static/media/Health.4fbd979cfb6cb3e31b43f5cf49511687.svg";
export { ForwardRef as ReactComponent };